module.exports = __webpack_public_path__ + "static/media/philosophy-enrolled.77f563f7.svg";